import { PHONE_NUMBER } from "../../constants/ProductConstants";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../context/ToastContext";
import { useState } from "react";

// UI IMPROVED VERSION — NO FUNCTIONALITY CHANGED

export default function ProductCard({ product, addToCart, small = false }) {
    const { showToast } = useToast();
    const [selectedColorIndex, setSelectedColorIndex] = useState(0);
    const [isImageFading, setIsImageFading] = useState(false);
    const navigate = useNavigate();

    const handleBuyNow = () => {
        const phone = PHONE_NUMBER;
        const message = `Hi, I want to order:\n\n${product.name}\nPrice: ₹${product.price}`;
        const url = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
        window.open(url, "_blank");
    };

    const discountPercent = product.originalPrice
        ? Math.round(
            ((product.originalPrice - product.price) / product.originalPrice) * 100
        )
        : 0;

    const selectedImage = product.colors && product.colors.length > 0
        ? product.colors[selectedColorIndex].image
        : product.image;

    const selectedColorName = product.colors && product.colors.length > 0
        ? product.colors[selectedColorIndex].name
        : null;

    return (
        <div
            style={{ ...styles.card, ...(small ? styles.cardSmall : {}) }}
            onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-4px)";
                e.currentTarget.style.boxShadow = "0 10px 25px rgba(0,0,0,0.08)";
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.04)";
            }}
        >

            {/* DISCOUNT BADGE */}
            {discountPercent > 0 && (
                <span style={styles.badge}>{discountPercent}% OFF</span>
            )}

            <div>
                {/* IMAGE */}
                <div
                    style={styles.imageWrapper}
                    onClick={() => navigate(`/product/${product.id}`, { state: { product } })}
                >
                    <img
                        src={selectedImage}
                        alt=""
                        style={{
                            ...styles.image,
                            opacity: isImageFading ? 0.4 : 1 // 👈 move here
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "scale(1.04)";
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "scale(1)";
                        }}
                    />
                </div>

                {/* COLORS */}
                {product.colors && product.colors.length > 0 && (
                    <>
                        <div style={styles.swatchContainer}>
                            {product.colors.map((c, i) => (
                                <button
                                    key={c.name + i}
                                    onClick={() => {
                                        setIsImageFading(true);
                                        setTimeout(() => {
                                            setSelectedColorIndex(i);
                                            setIsImageFading(false);
                                        }, 120); // smooth + fast
                                    }}
                                    style={{
                                        ...styles.swatch,
                                        background: c.hex,
                                        border: "1px solid rgba(0,0,0,0.06)",
                                        transform: i === selectedColorIndex ? "scale(1.15)" : "scale(1)",
                                        boxShadow: i === selectedColorIndex
                                            ? "0 0 0 2px #fff, 0 0 0 3px rgba(0,0,0,0.15)"
                                            : "none"
                                    }}
                                />
                            ))}
                        </div>
                        {selectedColorName && (
                            <span style={styles.colorName}>
                                in {selectedColorName}
                            </span>
                        )}
                    </>
                )}

                {/* NAME */}
                <h3 style={styles.name}>{product.name}</h3>

                {/* PRICE */}
                <div style={styles.priceRow}>
                    <span style={styles.price}>₹{product.price}</span>
                    {product.originalPrice && (
                        <span style={styles.originalPrice}>
                            ₹{product.originalPrice}
                        </span>
                    )}
                </div>

                {!product.colors[selectedColorIndex].stock && (
                    <span style={styles.soldOut}>Sold Out</span>
                )}
            </div>

            {/* ONLY ADD TO CART (Buy Now removed) */}
            <div style={styles.buttonContainer}>
                <button
                    style={styles.addButton}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.boxShadow = "0 0 0 2px rgba(125,18,1,0.15)";
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.boxShadow = "none";
                    }}
                    onClick={() => {
                        const cartItem = {
                            ...product,
                            selectedColor: selectedColorName,
                            selectedColorIndex,
                            colorHex: product.colors?.[selectedColorIndex]?.hex,
                            image: selectedImage
                        };

                        addToCart(cartItem);
                        showToast(`${product.name}${selectedColorName ? ' (' + selectedColorName + ')' : ''} added to cart`, "success");
                    }}
                >
                    Add to Cart
                </button>
            </div>

        </div>
    );
}

const styles = {
    card: {
        position: "relative",
        background: "#fff",
        borderRadius: "18px",
        padding: "14px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
        minHeight: "300px",
        transition: "all 0.25s ease",
        boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
        marginBottom: "6px"
    },

    badge: {
        position: "absolute",
        top: "12px",
        left: "12px",
        background: "rgba(125, 18, 1, 0.9)", // 👈 replace old background
        backdropFilter: "blur(4px)",         // 👈 add this
        WebkitBackdropFilter: "blur(4px)",
        color: "#fff",
        padding: "4px 8px",
        fontSize: "11px",
        borderRadius: "20px",
        fontWeight: "500",
        letterSpacing: "0.3px",
        zIndex: 10,
    },

    imageWrapper: {
        overflow: "hidden",
        borderRadius: "14px"
    },

    image: {
        width: "100%",
        height: "180px",
        objectFit: "cover",
        transition: "opacity 0.2s ease, transform 0.3s ease",
    },

    swatchContainer: {
        display: "flex",
        gap: "6px",
        marginTop: "10px",
        marginBottom: "4px",
        alignItems: "center"
    },

    swatch: {
        width: "18px",
        height: "18px",
        borderRadius: "50%",
        cursor: "pointer",
        padding: 0,
        outline: "none",
        transition: "all 0.2s ease",
        position: "relative",
        transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)"
    },
    colorName: {
        fontSize: "11px",
        color: "#000",
        opacity: 0.5,
        marginTop: "4px",
        marginBottom: "6px",
        letterSpacing: "0.25px"
    },

    name: {
        fontSize: "14px",
        fontWeight: "500",
        lineHeight: "1.4",
        margin: "8px 0 2px",
        color: "#111",
        letterSpacing: "0.3px"
    },

    priceRow: {
        display: "flex",
        gap: "8px",
        alignItems: "center"
    },

    price: {
        fontWeight: "500",
        color: "#111",
        fontSize: "15px",
        letterSpacing: "0.25px"
    },

    originalPrice: {
        textDecoration: "line-through",
        color: "#aaa",
        fontSize: "12px"
    },

    buttonContainer: {
        marginTop: "10px"
    },

    addButton: {
        padding: "10px",
        width: "100%",
        background: "#fff",
        color: "#7D1201",
        border: "1.5px solid #7D1201",
        borderRadius: "10px",
        fontSize: "14px",
        fontWeight: "500",
        cursor: "pointer",
        transition: "all 0.25s ease"
    },
    // addButton: {
    //     padding: "10px",
    //     width: "100%",
    //     background: "#111", // 🔥 premium black instead of red
    //     color: "#fff",
    //     border: "none",
    //     borderRadius: "10px",
    //     fontSize: "13px",
    //     fontWeight: "500",
    //     cursor: "pointer",
    //     transition: "all 0.2s ease"
    // },

    soldOut: {
        position: "absolute",
        top: "12px",
        right: "12px",
        background: "#111",
        color: "#fff",
        padding: "4px 8px",
        fontSize: "11px",
        borderRadius: "6px"
    }
};